export default {
    data() {
        return {
            errors: {},
        }
    },
    watch: {
        apiError: function (val) {
            if (val && val.response) {
                if (val.response.data.errors) {
                    this.errors = val.response.data.errors;
                } else {
                    this.errors = {};
                }
                switch (val.response.status) {
                    case 401:
                        this.$router.push({
                            name: "home"
                        }).catch(err => {});
                        break;
                    case 419:
                        this.$router.push({
                            name: "home",
                            params: {
                                userSlug: this.menu.user.slug
                            }
                        }).catch(err => {});
                        break;
                    case 404:
                        this.$router.push({
                            name: "404"
                        }).catch(err => {});
                        break;
                }
            }
        }
    }
};
